import { render } from "./ParserSection.vue?vue&type=template&id=fd04522e"
import script from "./ParserSection.vue?vue&type=script&lang=js"
export * from "./ParserSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__